// src/components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';
import { isAuthenticated } from '../utils/auth';
import DeactivatedAccount from '../pages/DeactivatedAccount';

const ProtectedRoute = ({ children, requireAdmin = false, requireJournalist = false }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  const user = JSON.parse(localStorage.getItem('user') || '{}');

  // Check if account is deactivated (but allow access to DeactivatedAccount page itself)
  if (user.is_active === false && window.location.pathname !== '/deactivated') {
    return <DeactivatedAccount />;
  }

  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireJournalist && user.role !== 'journalist' && user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;

